export default __webpack_public_path__ + "static/eagle-4c1e6acc5c98bce837a39018564f88f2.png";